
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import React from "react";
import { AppMisc } from "../../../../../misc/appMisc";
import styles from "../../style";
import { TRANSFER_PROMOTION_TYPE } from "../../../../../utils/constants";

export default function TransferAndPromotionDetails({ transferAndPromotionDetails }) {
  const classes = styles();

  return (
    <Box className={classes.root} p={2}>
      <Grid container>
        <TableContainer className={classes.currentServiceDetailsTable}>
          <Table size="small" className="table-bordered" aria-label="Staff Current Service Details">
            <TableBody>
              <TableRow>
                <TableCell>प्रकार: {AppMisc.getLabelFromValue(transferAndPromotionDetails?.transferOrPromotionType, TRANSFER_PROMOTION_TYPE)}</TableCell>
                <TableCell>अघिल्लो कार्यालय: {transferAndPromotionDetails?.previousOffice}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>अघिल्लो पद: {transferAndPromotionDetails?.previousPosition}</TableCell>
                <TableCell>हालको कार्यालय: {transferAndPromotionDetails?.newOffice}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>हालको पद: {transferAndPromotionDetails?.newPosition}</TableCell>
                <TableCell>लागू हुने मिति: {transferAndPromotionDetails?.effectiveDateInBS}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>निर्णय मिति: {transferAndPromotionDetails?.decisionDateInBS}</TableCell>
                <TableCell>कैफियत: {transferAndPromotionDetails?.remarks}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Box>
  );
}
